import { useQuery } from "@apollo/client";
import { DeliveryFilter, DeliveryLocationsQuery, DeliveryLocationsQueryVariables } from "_graphql/queries/__generated__/graphql";
import { getDeliveryLocations } from "_graphql/queries/delivery";

const useGetDeliveryLocations = (filter?: DeliveryFilter) => {
  const { data, loading, error } = useQuery<
    DeliveryLocationsQuery,
    DeliveryLocationsQueryVariables
  >(getDeliveryLocations, {
    variables: {
      filter,
    },
  });
  return { data, loading, error };
};

export default useGetDeliveryLocations;